import React, { useState, useEffect, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs-plugin-utc";
import useDocumentTitle from "../../utils/useDocumentTitle";

import AuthApi from "../../context/AuthApi";
import styles from "./Teams.module.scss";

import { DashboardLayout } from "../../layouts/DashboardLayout";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import BackButton from "../../components/BackButton";
import Button from "@material-ui/core/Button";

import { apiRequest } from "../../utils/api";
import { useNotification } from "../../context/notification";
import { getLocalValue } from "../../utils/auth";
import { useTranslation } from "react-i18next";
import { getQueryVariable } from "../../utils/getQueryParam";

dayjs.extend(utc);

export function TeamPersonalProfile(props) {
  useDocumentTitle(props.title);
  const { t } = useTranslation();
  const Auth = useContext(AuthApi);
  const history = useHistory();
  const { id } = useParams();
  const fromCampaign = getQueryVariable("campaign");
  const { addNotification } = useNotification();
  const [teamData, setTeamData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [viewLogUrl, setViewLogUrl] = useState("/logs/team");
  const [sessionUrl, setSessionUrl] = useState("/sessions/personal");

  useEffect(() => {
    // fetch from getSessionDetails api
    console.log("fromCampaign", fromCampaign);
    async function fetchData() {
      setIsLoading(true);
      const coacheeId =
        window.location.pathname === "/profile/" ? getLocalValue("uid") : id;
      const response = await apiRequest.get(
        `/api/getCoacheePersonalData?coachee_id=${coacheeId}`
      );

      if (response.status === 200) {
        const data = response.data.data;
        if (data.length > 0) {
          setTeamData(data);
          setViewLogUrl(
            data[0].uid === parseInt(getLocalValue("uid"))
              ? "/logs/personal"
              : `${fromCampaign ? "/logs/campaign" : "/logs/team"}?id=${
                  data[0].uid
                }&name=${data[0].u_fullname}`
          );
          setSessionUrl(
            data[0].uid === parseInt(getLocalValue("uid"))
              ? "/sessions/personal"
              : `${fromCampaign ? "/sessions/campaign/" : "/sessions/teams/"}${
                  data[0].uid
                }?name=${data[0].u_fullname}`
          ); //`/sessions/teams/${data[0].uid}?name=${data[0].u_fullname}`
        }
      } else {
        addNotification(
          t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
          "error"
        );
      }
      setIsLoading(false);
    }

    fetchData();
  }, []);

  const getProfileValue = field => {
    return teamData && teamData.length > 0 ? teamData[0][field] : null;
  };

  return (
    <DashboardLayout>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <div className={styles.profileContainer}>
              {Auth.isCoach && (
                <div className={styles.backButtonWrapper}>
                  <BackButton />
                </div>
              )}
              <div className={styles.profileWrapper}>
                <SectionTitle>
                  {t("personalProfile.personalProfile")}
                </SectionTitle>
                {teamData && (
                  <div className={styles.detailsContainer}>
                    <div className={styles.profileRow}>
                      <div className={styles.rowLeft}>
                        {t("personalProfile.fullName")}
                      </div>
                      <div className={styles.rowRight}>
                        {getProfileValue("u_fullname")}
                      </div>
                    </div>
                    <div className={styles.profileRow}>
                      <div className={styles.rowLeft}>
                        {t("personalProfile.employeeID")}
                      </div>
                      <div className={styles.rowRight}>
                        {getProfileValue("employee_id")}
                      </div>
                    </div>
                    <div className={styles.profileRow}>
                      <div className={styles.rowLeft}>
                        {t("personalProfile.campaign")}
                      </div>
                      <div className={styles.rowRight}>
                        {getProfileValue("campaign_name")}
                      </div>
                    </div>
                    <div className={styles.profileRow}>
                      <div className={styles.rowLeft}>
                        {t("personalProfile.market")}
                      </div>
                      <div className={styles.rowRight}>
                        {getProfileValue("u_market")}
                      </div>
                    </div>
                    <div className={styles.profileRow}>
                      <div className={styles.rowLeft}>
                        {t("personalProfile.designation")}
                      </div>
                      <div className={styles.rowRight}>
                        {getProfileValue("u_designation")}
                      </div>
                    </div>
                    <div className={styles.profileRow}>
                      <div className={styles.rowLeft}>
                        {t("personalProfile.coach")}
                      </div>
                      <div className={styles.rowRight}>
                        {getProfileValue("coach_name")}
                      </div>
                    </div>

                    <Button
                      variant="outlined"
                      size="large"
                      className={styles.button}
                      onClick={() => {
                        history.push(sessionUrl);
                      }}
                    >
                      {t("personalProfile.viewSession")}
                    </Button>
                    <Button
                      variant="outlined"
                      size="large"
                      className={styles.button}
                      onClick={() => {
                        history.push(viewLogUrl);
                      }}
                    >
                      {t("personalProfile.viewLogs")}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </Section>
        </PageContent>
      </div>
    </DashboardLayout>
  );
}
